import { FuelCardInputModel } from '@ail/orders-api'
import { skipToken } from '@reduxjs/toolkit/query'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import {
  useGetFuelCardsQuery,
  usePostFuelCardMutation,
  usePutFuelCardMutation,
} from '../../../../../redux/api/ordersApi'
import { newItemId } from '../../../../../types/constants'
import FuelCard from '../../../../common/FuelCard/FuelCard'
import './EditFuelCard.scss'
import { Loader } from '../../../../common/Loader/Loader'

export function EditFuelCard() {
  const [editing, setEditing] = useState<FuelCardInputModel>()
  const params = useParams<{ id: string }>()
  const history = useHistory()
  const fuelCards = useGetFuelCardsQuery(params.id === newItemId ? skipToken : undefined)
  const [putFuelCard, { isLoading: isUpdating }] = usePutFuelCardMutation()
  const [postFuelCard, { isLoading: isCreating }] = usePostFuelCardMutation()
  const loading = fuelCards.isFetching || isUpdating || isCreating

  const fuelCard = useMemo(() => {
    return fuelCards.currentData?.find((fc) => fc.id.toLowerCase() === params.id.toLowerCase())
  }, [fuelCards.currentData, params.id])

  useEffect(() => {
    if (params.id === newItemId) {
      setEditing({ key: '', name: '', electric: false, carwash: false, supplierIds: [] })
    } else {
      setEditing(fuelCard)
    }
  }, [fuelCard, params.id])

  const save = useCallback(() => {
    if (params.id === newItemId) {
      postFuelCard(editing!).then(() => history.push('/RequestsManagement/FuelCards'))
    } else {
      putFuelCard({ id: params.id, model: editing! }).then(() => history.push('/RequestsManagement/FuelCards'))
    }
  }, [editing, history, params.id, postFuelCard, putFuelCard])

  return (
    <Loader blocking={loading} style={{ overflow: 'hidden' }} className="editFuel">
      <div className="ordersArea newFormArea">
        <div className="ordersFormArea">
          <div className="detailTitle">
            <i className="icon-fuelcard"></i>
            <span>New/Edit Fuel Card</span>
          </div>
          {!!editing && (
            <>
              <div className="ordersForm">
                <div className="row">
                  <div className="col-12 col-sm-6">
                    <div className="formGroup">
                      <label>Key </label>
                      <input
                        type="text"
                        name={`uniqueName${new Date().getTime()}`}
                        autoComplete="none"
                        list="autocompleteOff"
                        value={editing.key}
                        onChange={(e) => setEditing({ ...editing, key: e.target.value })}
                      />
                    </div>
                    <div className="formGroup">
                      <label>Display name </label>
                      <input
                        type="text"
                        name={`uniqueName${new Date().getTime()}`}
                        autoComplete="none"
                        list="autocompleteOff"
                        value={editing.name}
                        onChange={(e) => setEditing({ ...editing, name: e.target.value })}
                      />
                    </div>
                    <div className="formGroup">
                      <label>Supplier ids (comma separated)</label>
                      <input
                        type="text"
                        name={`uniqueName${new Date().getTime()}`}
                        autoComplete="none"
                        list="autocompleteOff"
                        value={editing.supplierIds.map((i) => i.trim()).join(',')}
                        onChange={(e) => setEditing({ ...editing, supplierIds: e.target.value.split(',') })}
                      />
                    </div>
                    <div className="formGroup flex" style={{ gridGap: '20px', marginBottom: 0 }}>
                      <div className="flex" style={{ gridGap: '5px' }}>
                        <i className="icon-fuelcard-electric" />
                        <input
                          type="checkBox"
                          name={`uniqueName${new Date().getTime()}`}
                          autoComplete="none"
                          list="autocompleteOff"
                          checked={editing.electric}
                          onChange={(e) => setEditing({ ...editing, electric: e.target.checked })}
                        />
                      </div>
                      <div className="flex" style={{ gridGap: '5px' }}>
                        <i className="icon-car-wash" />
                        <input
                          type="checkBox"
                          name={`uniqueName${new Date().getTime()}`}
                          autoComplete="none"
                          list="autocompleteOff"
                          checked={editing.carwash}
                          onChange={(e) => setEditing({ ...editing, carwash: e.target.checked })}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-sm-6">
                    <ul className="fuelList">
                      <li style={{ flexBasis: '100%' }}>
                        <FuelCard managementFuelCard={editing} />
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="btnArea">
                <button className="btn btnClose" onClick={() => history.push('/RequestsManagement/FuelCards')}>
                  <i className="icon-close"></i> Cancel
                </button>
                <button className="btn btnSave" onClick={save}>
                  <i className="icon-save"></i> Save
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </Loader>
  )
}
